
import request from '@/utils/request'

// 获得新闻列表
export function getNewsList() {
    return request({
        url: '/gtwg/pc/newsList',
        method: 'get'
    })
}
// 新闻明细
export function getNewsDetail(data) {
    // {contentId}
    return request({
        url: '/gtwg/pc/contentDetails',
        method: 'get',
        params:data
    })
}
//  根据栏目获得列表
export function getContentList(data) {
    // {contentId}
    return request({
        url: '/gtwg/pc/contentList',
        method: 'get',
        params:data
    })
}